module.exports = __webpack_public_path__ + "static/media/7_Days of the Week.16bf40ae.jpg";